<template>
  <section class="LKPublicationsContainer">
    <h3
      class="LKPublicationsContainer__title"
      v-text="title"
    />

    <slot />
  </section>
</template>

<script>
export default {
  name: 'LKPublicationsContainer',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
$border-color: #bcd5fa;

.LKPublicationsContainer {
  border-top: 3px solid $border-color;

  &__title {
    padding: 20px 0;
    font-size: 18px;
    font-weight: bold;
    color: $webflow-color-blue-dark-3;
  }
}
</style>
